import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { ColorBrandBlue2 } from 'autogen/design-tokens/tokens';
import * as transKey from 'autogen/translation-keys/trans-root-website';
import { Button, ButtonWithIcon } from 'components/Button';
import type IButton from 'components/Button/shared/types/button';
import Icon from 'components/Icon';
import { SelectItemCallbackContext } from '../hooks/contexts';
import type { itemState } from '../shared/types';

const sharedButtonStyle = css`
    width: 100%;
`;

const StyledButton = styled(Button)`
    ${sharedButtonStyle};
`;

const StyledButtonWithIcon = styled(ButtonWithIcon)`
    ${sharedButtonStyle};
`;

const ChosenButton = styled(ButtonWithIcon)`
    ${sharedButtonStyle};
    background-color: ${ColorBrandBlue2};
`;

interface IChooseButton extends IButton {
    state: itemState;
    productId: number;
    isRecommended: boolean;
}

export default function ChooseButton({ state, productId, isRecommended, ...restProps }: IChooseButton): JSX.Element {
    const selectItemCallback = useContext(SelectItemCallbackContext);
    const { t } = useTranslation();
    const { ChooseSampleButton, ChosenSampleButton, LockedSampleButton } = transKey.Basket.Samples.SamplesPicker;

    switch (state) {
        case 'locked':
            return (
                <StyledButtonWithIcon icon={<Icon type="Lock" size={16} />} disabled {...restProps}>
                    {t(LockedSampleButton)}
                </StyledButtonWithIcon>
            );
        case 'chosen':
            return (
                <ChosenButton
                    icon={<Icon type="Checkmark" size={16} />}
                    {...restProps}
                    onClick={() => {
                        selectItemCallback('chosen', productId, isRecommended);
                    }}
                >
                    {t(ChosenSampleButton)}
                </ChosenButton>
            );
        default:
            return (
                <StyledButton
                    {...restProps}
                    onClick={() => {
                        selectItemCallback('choose', productId, isRecommended);
                    }}
                >
                    {t(ChooseSampleButton)}
                </StyledButton>
            );
    }
}
